import { FC } from 'react';
import { Grid, FormControl, TextField, Select, MenuItem, InputLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SCUIButton } from '../../../../atomic/atoms';
import { SCUIGeneralDrawerHeader } from '../../../../atomic/molecules';
import { LOC, locCls } from '../../localizationManagement.classes';

interface IProps {
    cultureList?: any;
    filterInput?: any;
    setFilterInput?: any;
    onClose?: any;
    applicationList: any;
    setPageNumber: any;
}

export const SCUILocalizationFilter: FC<IProps> = ({
    cultureList,
    filterInput,
    setFilterInput,
    onClose,
    applicationList,
    setPageNumber,
}) => {
    const { t } = useTranslation();
    return (
        <form
            onSubmit={async (e: any) => {
                e.preventDefault();
                setFilterInput({
                    appId: filterInput.appId,
                    cultureCode: filterInput.cultureCode,
                    keyword: filterInput.keyword,
                    page: 0,
                });
                setPageNumber(0);
            }}
        >
            <div className={locCls('commentFilterContainer', LOC.filterDrawerBody)}>
                <Grid container spacing={1}>
                    <SCUIGeneralDrawerHeader
                        header={t('general.detailedFiltering')}
                        onClose={onClose}
                        rootClassName={LOC.filterDrawerHeaderRoot}
                        titleClassName={LOC.filterDrawerHeaderTitle}
                        closeIconClassName={LOC.inputIconFilterDrawerClose}
                    />
                    <Grid
                        className={LOC.filterDrawerAppField}
                        style={{ marginTop: '20px' }}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <FormControl fullWidth>
                            <InputLabel id="regionLabel">{t('general.selectApp')}</InputLabel>
                            <Select
                                className={LOC.inputSelectFilterApp}
                                label={t('general.selectApp')}
                                labelId="labelApp"
                                id="parentMenuLabel"
                                defaultValue={filterInput.appId}
                                onChange={(event) => {
                                    filterInput.appId = Number(event.target.value);
                                }}
                            >
                                {applicationList &&
                                    applicationList.map((app: any) => (
                                        <MenuItem
                                            key={app.applicationId}
                                            id={app.applicationId}
                                            value={app.applicationId}
                                        >
                                            {app.applicationName}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid
                        className={LOC.filterDrawerCultureField}
                        style={{ marginTop: '20px' }}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <FormControl fullWidth>
                            <InputLabel id="cultureLabel">{t('general.selectCulture')}</InputLabel>
                            <Select
                                className={LOC.inputSelectFilterCulture}
                                fullWidth
                                label={'Kültürler'}
                                labelId="cultureLabel"
                                id="selectCulture"
                                defaultValue={filterInput.cultureCode}
                                onChange={(event) => {
                                    filterInput.cultureCode = event.target.value;
                                }}
                            >
                                {cultureList &&
                                    cultureList.map((culture: any) => (
                                        <MenuItem key={culture.id} id={culture.id} value={culture.code}>
                                            {culture.code}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid
                        className={LOC.filterDrawerKeywordField}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <TextField
                            className={LOC.inputTextFilterKeyword}
                            label={t('general.keyword')}
                            variant="outlined"
                            type="text"
                            id="keywordText"
                            fullWidth
                            defaultValue={filterInput.keyword}
                            onChange={(event) => {
                                filterInput.keyword = event.target.value;
                            }}
                        />
                    </Grid>
                    <Grid
                        className={LOC.filterDrawerFooter}
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            marginTop: '10px',
                        }}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <SCUIButton
                            className={LOC.inputButtonFilterApply}
                            text={t('general.filter')}
                            type="primary"
                            sizeType="fixed"
                            size={'l'}
                        />
                    </Grid>
                </Grid>
            </div>
        </form>
    );
};
